module.exports = __webpack_public_path__ + "static/img/user1.460e69d5.png";